import * as Bananas from "bananas-commerce-admin";

import { Newspaper, ReceiptLong } from "@mui/icons-material";

import OrderDetailPage from "./pages/order/Detail";
import OrderListPage from "./pages/order/List";
import PublicationDetailPage from "./pages/publication/Detail";
import PublicationListPage from "./pages/publication/List";

export const publicationRouter: Bananas.RouterExtension = {
  app: "publications",
  pages: (route) => {
    if (route.action === "get") {
      return {
        page: PublicationListPage,
        offline: false,
      };
    }
    if (route.action === "detail") {
      return {
        page: PublicationDetailPage,
        offline: true,
      };
    }
    return undefined;
  },
};

export const orderRouter: Bananas.RouterExtension = {
  app: "mediahouse",
  pages: (route) => {
    if (route.action === "list") {
      return {
        page: OrderListPage as Bananas.types.PageComponent,
        offline: false,
      };
    }
    if (route.action === "detail") {
      return {
        page: OrderDetailPage,
        offline: true,
      };
    }
    return undefined;
  },
};

// TODO Do some actual routing once I have figured out how it works /Johannes
export const navigation: Bananas.types.NavigationOverrides = {
  "mediahouse.publications:get": {
    title: "Utgivning",
    icon: Newspaper,
    group: "mediauser",
    excludedGroup: "Klarahill admin",
    route: {
      action: "get",
      app: "publications",
      id: "mediahouse.publications:get",
      navigation: true,
      page: "publications",
      path: "/publications/",
      title: "Utgivning",
      view: "publications",
    },
  },
  "mediahouse.publications:detail": {
    title: "Publication Details",
    icon: Newspaper,
    group: "mediauser",
    hidden: true,
    route: {
      action: "detail",
      app: "publications",
      id: "mediahouse.publications:detail",
      navigation: true,
      page: "publications",
      path: "/publications/:abbreviation",
      title: "Publication Details",
      view: "publications",
    },
  },
  "mediahouse.obituaries:list": {
    title: "Ordrar",
    icon: ReceiptLong,
    group: "mediauser",
    excludedGroup: "Klarahill admin",
    route: {
      action: "list",
      app: "mediahouse",
      id: "mediahouse.obituaries:list",
      navigation: true,
      page: "order",
      path: "/obituaries/",
      title: "Ordrar",
      view: "order",
    },
  },
  "mediahouse.obituaries:detail": {
    title: "Order Details",
    icon: ReceiptLong,
    group: "mediauser",
    hidden: true,
    route: {
      action: "detail",
      app: "mediahouse",
      id: "mediahouse.obituaries:detail",
      navigation: true,
      page: "order",
      path: "/obituaries/:obituary_id",
      title: "Order Details",
      view: "order",
    },
  },
} as const;
